import Action from './Action.component';

export default Action;
